export default __webpack_public_path__ + "static/media/bg3.24e47815.png";